export const GOFUNDME_URL =
  "https://www.gofundme.com/f/syncroo?attribution_id=sl%3Abcc6608d-8349-4b0a-bbce-c4adac5d67e5&lang=it_IT&ts=1784844176&utm_campaign=man_ss_icons&utm_content=amp20_t1&utm_medium=customer&utm_source=copy_link&cp_src=m&fbclid=PAT01DUAT7JQxwZG9mAmV4dG4DYWVtAjEwAHNydGMGYXBwX2lkDzU2NzA2NzM0MzM1MjQyNwABp5zDlYaYbFPj79OCw8YuNDVMhcqcWDBqzAfvRd2JE7_0-DabvkYEEn89RWcV_aem_kdLp_ULSzo6HCbVTeAakng";

export const gofundmeUrl = (locale) =>
  locale === "en" ? GOFUNDME_URL.replace("lang=it_IT", "lang=en_US") : GOFUNDME_URL;

export const translations = {
  it: {
    nav: {
      cta: "Waiting list",
      login: "Accedi",
      logout: "Esci",
      admin: "Iscritti",
    },
    hero: {
      overline: "SYNCROO.IT · SYNCROO.EU — BETA IN ARRIVO SUL PLAY STORE",
      title: "SYNCROO",
      tagline1: "La tecnologia che ti riporta",
      tagline2: "nel mondo reale.",
      sub: "Crea la tua Crew, proponi un'uscita o unisciti a un Tavolo Social: Syncroo accende la tua città con le persone giuste.",
      primaryCta: "Entra in waiting list",
      secondaryCta: "Sostieni su GoFundMe",
      scroll: "Scorri per scoprire",
    },
    marquee: [
      "Riporteremo le persone nel mondo reale",
      "Crews",
      "Tavoli Social",
      "Uscite",
      "Viaggi",
      "Live",
      "Locali & offerte",
    ],
    manifesto: {
      overline: "Il manifesto",
      heading: "Perché Syncroo",
      chapters: [
        {
          num: "01",
          title: "Il paradosso",
          text: "Viviamo nell'epoca più connessa di sempre, eppure non è mai stato così difficile stringere legami veri. Scrolliamo schermi infiniti cercando qualcosa che assomigli a un'amicizia autentica, finendo spesso in relazioni superficiali.",
        },
        {
          num: "02",
          title: "Non un'app di incontri",
          text: "Syncroo nasce per ribaltare tutto questo. Gli swipe ci sono, ma funzionano con un sistema di affinità: conosci persone con interessi simili ai tuoi, in un gioco che va oltre l'aspetto fisico. E poi ci si incontra davvero, nel mondo reale.",
        },
        {
          num: "03",
          title: "Crews, Tavoli e Live",
          text: "Crea o unisciti a una Crew, proponi un'uscita in pochi tap o siediti a un Tavolo Social con offerte esclusive nei locali vicino a te. Poi racconta tutto in diretta con le Live.",
        },
        {
          num: "04",
          title: "Il lancio",
          text: "L'app è costruita, plasmata, rifinita. La beta sta per arrivare sul Play Store: entra in waiting list per provarla tra i primi, darci feedback e aiutarci a renderla perfetta.",
        },
      ],
    },
    waitlist: {
      overline: "Waiting list",
      heading: "Entra in sync.",
      sub: "Lasciaci nome, email e perché ti interessa: sarai tra i primi a scaricare la beta e a fondare la tua Crew.",
      nameLabel: "Nome",
      namePlaceholder: "Il tuo nome",
      emailLabel: "Email",
      emailPlaceholder: "nome@email.com",
      cityLabel: "Città (facoltativo)",
      cityPlaceholder: "Es. Foggia",
      motivationLabel: "Perché ti interessa Syncroo?",
      motivationPlaceholder: "Viaggi, concerti, trekking, nuove amicizie... raccontacelo in una riga.",
      submit: "Sincronizzami",
      submitting: "Sync in corso...",
      counter: (n) => `${n} ${n === 1 ? "persona già in sync" : "persone già in sync"}`,
      counterZero: "Sii la prima persona in sync",
      verified: "Email verificata con il tuo account Google",
      successTitle: "Sei in sync.",
      successText: "Ti scriveremo appena la beta apre. Intanto, ci vediamo là fuori.",
      existsTitle: "Sei già dei nostri.",
      existsText: "Questa email è già in waiting list. Ci vediamo al lancio!",
      errorText: "Qualcosa non ha funzionato. Riprova tra un attimo.",
      invalidText: "Controlla i campi: servono nome, una email valida e la tua motivazione.",
    },
    funding: {
      overline: "La raccolta fondi",
      titleA: "Diventa un",
      titleB: "Genesis Donor",
      text: "I fondi raccolti su GoFundMe servono in questa fase cruciale per potenziare i server, blindare la sicurezza e accendere il motore di una community fatta per durare. E c'è di più: i maggiori donatori avranno vantaggi esclusivi quando Syncroo aprirà.",
      benefitsTitle: "Vantaggi per i maggiori donatori",
      benefits: [
        "Accesso anticipato garantito alla beta e alle prossime release",
        "Badge \"Founder\" esclusivo sul tuo profilo Syncroo",
        "Il tuo nome nei credits dell'app, per sempre",
        "Vantaggi e privilegi riservati al lancio ufficiale",
      ],
      cta: "Dona su GoFundMe",
      note: "La donazione avviene in sicurezza su gofundme.com",
    },
    footer: {
      domains: "syncroo.it · syncroo.eu",
      claim: "Riportiamo le persone nel mondo reale.",
      made: "Nato a Foggia, Italia — 2026",
      waitlist: "Waiting list",
      funding: "GoFundMe",
    },
  },
  en: {
    nav: {
      cta: "Waitlist",
      login: "Sign in",
      logout: "Sign out",
      admin: "Signups",
    },
    hero: {
      overline: "SYNCROO.IT · SYNCROO.EU — BETA COMING TO PLAY STORE",
      title: "SYNCROO",
      tagline1: "Technology that brings you back",
      tagline2: "to the real world.",
      sub: "Create your Crew, propose a hangout or join a Social Table: Syncroo lights up your city with the right people.",
      primaryCta: "Join the waitlist",
      secondaryCta: "Back us on GoFundMe",
      scroll: "Scroll to explore",
    },
    marquee: [
      "Bringing people back to the real world",
      "Crews",
      "Social Tables",
      "Hangouts",
      "Trips",
      "Lives",
      "Venues & deals",
    ],
    manifesto: {
      overline: "The manifesto",
      heading: "Why Syncroo",
      chapters: [
        {
          num: "01",
          title: "The paradox",
          text: "We live in the most connected era ever, yet making real bonds has never been harder. We scroll endless feeds looking for something that resembles a true friendship, and too often end up in shallow connections.",
        },
        {
          num: "02",
          title: "Not a dating app",
          text: "Syncroo was born to flip all of this. Swipes do exist, but they run on an affinity system: you meet people who share your interests — something that goes far beyond looks. Then you actually meet up, in the real world.",
        },
        {
          num: "03",
          title: "Crews, Tables & Lives",
          text: "Create or join a Crew, propose a hangout in a few taps or grab a seat at a Social Table with exclusive deals at venues near you. Then share it all in real time with Lives.",
        },
        {
          num: "04",
          title: "The launch",
          text: "The app is built, shaped and polished. The beta is about to land on the Play Store: join the waitlist to be among the first to try it, give us feedback and help us make it perfect.",
        },
      ],
    },
    waitlist: {
      overline: "Waitlist",
      heading: "Get in sync.",
      sub: "Leave your name, email and why you're interested: you'll be among the first to download the beta and found your Crew.",
      nameLabel: "Name",
      namePlaceholder: "Your name",
      emailLabel: "Email",
      emailPlaceholder: "name@email.com",
      cityLabel: "City (optional)",
      cityPlaceholder: "E.g. Milan",
      motivationLabel: "Why are you interested in Syncroo?",
      motivationPlaceholder: "Trips, gigs, hiking, new friendships... tell us in one line.",
      submit: "Sync me in",
      submitting: "Syncing...",
      counter: (n) => `${n} ${n === 1 ? "person already in sync" : "people already in sync"}`,
      counterZero: "Be the first one in sync",
      verified: "Email verified with your Google account",
      successTitle: "You're in sync.",
      successText: "We'll write to you as soon as the beta opens. Meanwhile, see you out there.",
      existsTitle: "You're already one of us.",
      existsText: "This email is already on the waitlist. See you at launch!",
      errorText: "Something went wrong. Please try again in a moment.",
      invalidText: "Check the fields: we need a name, a valid email and your motivation.",
    },
    funding: {
      overline: "The fundraiser",
      titleA: "Become a",
      titleB: "Genesis Donor",
      text: "Funds raised on GoFundMe will power this crucial phase: stronger servers, hardened security and the engine of a community built to last. And there's more: the top donors will get exclusive benefits when Syncroo opens.",
      benefitsTitle: "Perks for top donors",
      benefits: [
        "Guaranteed early access to the beta and future releases",
        "Exclusive \"Founder\" badge on your Syncroo profile",
        "Your name in the app credits, forever",
        "Reserved perks and privileges at the official launch",
      ],
      cta: "Donate on GoFundMe",
      note: "Donations are processed securely on gofundme.com",
    },
    footer: {
      domains: "syncroo.it · syncroo.eu",
      claim: "Bringing people back to the real world.",
      made: "Born in Foggia, Italy — 2026",
      waitlist: "Waitlist",
      funding: "GoFundMe",
    },
  },
};
